/* eslint-disable @typescript-eslint/no-use-before-define */

import { func } from "prop-types";
import { auth } from "@/services";

/* eslint-disable @typescript-eslint/explicit-function-return-type */
(function (angular) {
  angular.module("app").controller("feedController", feedController);

  feedController.$inject = [
    "FeedApi",
    "PollVotesApi",
    "Helpers",
    "$scope",
    "LikesApi",
    "CommentsApi",
    "UsersApi",
    "thisUser",
    "GroupsApi",
    "alerts",
  ];

  function feedController(
    FeedApi,
    PollVotesApi,
    Helpers,
    $scope,
    LikesApi,
    CommentsApi,
    UsersApi,
    thisUser,
    GroupsApi,
    alerts,
  ) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    const nowISO = window.moment().format(Helpers.isoFormat);

    vm.filters = {
      filter_by: null,
      order_by: "created_at",
      order: "desc",
      page: "1",
      per_page: 15,
      user_id: null,
    };

    // Get true or false value from site's setting to see if feed is enabled
    vm.feedEnabled = [];
    vm.feedItems = [];

    vm.getFilterTitles = getFilterTitles;
    vm.getLikes = getLikes;
    vm.getComments = getComments;
    vm.getLikesAndComments = getLikesAndComments;
    $scope.requestResource = requestResource;

    $scope.postComment = postComment;

    $scope.toggleLike = toggleLike;
    $scope.toggleComments = toggleComments;
    $scope.saveReply = saveReply;

    $scope.authenticated = thisUser !== null;

    if (thisUser) {
      $scope.usersGroups = thisUser.groups.map(function (group) {
        return group.id;
      });
    }

    vm.likesAndCommentsFilter = {
      filter_by: null,
      order_by: "created_at",
      order: "desc",
      user_id: null,
    };

    vm.usersFilter = {
      filter_by: null,
      order_by: "created_at",
      order: "desc",
      user_id: null,
    };

    vm.likes = [];
    vm.comments = [];

    vm.permissionChecks = {
      events: auth.hasPermission("events.view"),
      polls: auth.hasPermission("polls.view"),
      packages: auth.hasPermission("packages.view"),
      news: auth.hasPermission("news.view:directory"),
      resources: auth.hasPermission("resources.view"),
      promotions: auth.hasPermission("promotions.view"),
      users: auth.hasPermission("users.view:directory"),
    };

    vm.orderFilters = {
      all: {
        label: "Everything",
        filter_by: null,
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: null,
      },
      events: {
        label: "Events",
        filter_by: "events",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: null,
      },
      polls: {
        label: "Polls",
        filter_by: "polls",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: null,
      },
      packages: {
        label: "Packages",
        filter_by: "packages",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: null,
      },
      news: {
        label: "News",
        filter_by: "news",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: null,
      },
      resources: {
        label: "Resources",
        filter_by: "resources",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: null,
      },
      promotions: {
        label: "Promotions",
        filter_by: "promotions",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: null,
      },
      users: {
        label: "Members",
        filter_by: "users",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: "20",
        user_id: null,
      },
    };

    if (thisUser) {
      // Check user permissions and filter orderFilters accordingly
      Object.keys(vm.orderFilters).forEach((key) => {
        // If there is a corresponding permission check for the key and it's false, remove it
        if (key !== "all" && !vm.permissionChecks[key]) {
          delete vm.orderFilters[key];
        }
      });
    }

    //need to remove any filters that the user doesnt have access too here

    vm.selectedOrderFilter = vm.orderFilters.all;

    //** date order */
    vm.orderdateFilters = {
      descending: {
        label: "Last activity",
        order_by: "created_at",
        order: "desc",
        page: "1",
        per_page: 15,
        user_id: null,
      },
      ascending: {
        label: "First activity",
        order_by: "created_at",
        order: "asc",
        page: "1",
        per_page: 15,
        user_id: null,
      },
    };

    vm.selectedOrderdateFilter = vm.orderdateFilters.descending;
    //**date order finishes here */

    vm.getFeed = getFeed;
    vm.orderFeed = orderFeed;

    // $scope.cancelReply = cancelReply;

    const replyFormat = {
      id: null,
      parent_id: null,
      body: "",
      entities: [],
      item_id: null,
      item_type: "poll",
      saving: false,
    };

    enum API_ROUTE {
      LIKES = "/api/likes",
      COMMENTS = "/api/comments",
    }

    vm.likedByUser = (feedItemId) => {
      const user = vm.feedItems.find((f) => f.id === feedItemId);

      if (!user) return false;

      return user.likes.filter((x) => x.user_id === thisUser.id).length > 0;
    };

    function extendUserData(list: object[]) {
      const handleSuccess = (response) => {
        const { data } = response;

        list.map((item: any) => {
          const user = data.find((x) => x.id === item.user_id);

          if (user) {
            const { id, full_name, slug, img, initials } = user;
            item["user"] = { id, full_name, slug, img, initials };
          }
        });
        return list;
      };

      UsersApi.get(vm.usersFilter, handleSuccess);
      return list ?? [];
    }

    function getFilterTitles() {
      fetch("/api/settings/titles")
        .then((response) => response.json())
        .then((data) => {
          for (const [key, value] of Object.entries(data.data)) {
            vm.orderFilters[key].label = value;
          }
        })
        .catch((error) => {
          console.error("Error fetching filter titles:", error);
        });
    }

    function getLikes(feedItemId = null) {
      const handleResponse = (response) => {
        const { data } = response;

        if (!feedItemId) {
          vm.likes = data.length ? extendUserData(data) : [];
        } else {
          const feedItem = vm.feedItems.find((i) => i.id === feedItemId);

          if (!feedItem) return;

          feedItem["showFooter"] = thisUser !== null;
          feedItem["likes"] = data.length ? extendUserData(data) : [];
          if ($scope.authenticated) {
            feedItem["liked"] =
              feedItem.likes.filter((like) => like.user_id === thisUser.id)
                .length > 0;
          }
        }
      };

      const filters = vm.likesAndCommentsFilter;

      if (feedItemId) {
        filters["item_id"] = feedItemId;
      }

      return LikesApi.get(filters, handleResponse);
    }

    function getComments(feedItemId = null) {
      let feedItem;

      const handleResponse = (response) => {
        const { data } = response;

        if (!feedItemId) {
          vm.comments = data.length ? extendUserData(data) : [];
        } else {
          feedItem = vm.feedItems.find((i) => i.id === feedItemId);

          if (!feedItem) return;
          feedItem["comments"] = data.length ? extendUserData(data) : [];
          feedItem["surfaceComments"] = feedItem.comments.filter(
            (comment) => comment.parent_id === null,
          );
          feedItem["replies"] = feedItem.comments.filter(
            (comment) => comment.parent_id === feedItemId,
          );

          if (feedItem["liked"] !== undefined && $scope.authenticated) {
            feedItem.liked =
              feedItem.likes.filter((like) => like.user_id === thisUser.id)
                .length > 0;
          }

          if (feedItem.comments.length) {
            feedItem.comments.map((comment) => {
              comment["isReply"] = comment.parent_id != null;
              comment["parent"] = null;
              comment["replies"] = [];
              comment["deleted"] = false;

              if (
                comment.isReply &&
                !feedItem.comments.find((c) => c.id === comment.parent_id)
              ) {
                comment["deleted"] = true;
              }

              if (comment["isReply"]) {
                comment["parent"] =
                  feedItem.comments.find((c) => c.id === comment.parent_id) ??
                  null;
                comment["parentId"] = comment.parent ? comment.parent.id : null;
                comment["replies"] = feedItem.comments.filter(
                  (c) => c.parent_id === comment.id,
                );
              } else {
                comment["replies"] = feedItem.comments.filter(
                  (c) => c.parent_id === comment.id,
                );
              }
            });
          }
        }
      };

      const filters = vm.likesAndCommentsFilter;

      if (feedItemId) {
        filters["item_id"] = feedItemId;
      }

      return CommentsApi.get(filters, handleResponse);
    }

    async function getLikesAndComments() {
      if (vm.feedItems) {
        vm.feedItems.map((feedItem) => {
          const { id, itemType, user } = feedItem;

          if (feedItem["likes"] === undefined) feedItem["likes"] = [];
          if (feedItem["liked"] === undefined) feedItem["liked"] = false;
          if (feedItem["comments"] === undefined) feedItem["comments"] = [];
          if (feedItem["replies"] === undefined) feedItem["replies"] = [];
          if (feedItem["commentsLoading"] === undefined)
            feedItem["commentsLoading"] = false;
          if (feedItem["showComments"] === undefined)
            feedItem["showComments"] = false;

          if (
            itemType === "poll" ||
            itemType === "news" ||
            itemType === "resource"
          ) {
            vm.getLikes(id);
            vm.getComments(id);

            if ($scope.authenticated && feedItem["liked"] !== undefined) {
              feedItem.liked =
                feedItem.likes.filter((like) => like.user_id === thisUser.id)
                  .length > 0;
            }
          }
        });
      }
    }

    function toggleComments(feedItemId) {
      if (!feedItemId) return;

      const feedItem = vm.feedItems.find((item) => item.id === feedItemId);

      if (!feedItem.showComments) vm.getComments(feedItemId);
      feedItem.showComments = !feedItem.showComments;
    }

    function toggleReplyBox(feedItemId, state = null) {
      if (state != null && typeof state !== "boolean") return;

      if (state === null) {
        return ($scope.replyBoxOpen = !$scope.replyBoxOpen);
      }

      if (!feedItemId) return;

      const feedItem = vm.feedItems.find((item) => item.id == feedItemId);
      if (!feedItem) return;

      return (feedItem.replyBoxOpen = state);
    }

    /**
     * Toggles a User's *like* on a Poll
     * @return {void}
     */
    function toggleLike(feedItemId) {
      if (!feedItemId) return;

      const feedItem = vm.feedItems.find((item) => item.id === feedItemId);
      if (!feedItem) return;

      // vm.getLikes();

      const method = feedItem.liked ? "DELETE" : "POST";

      // If isLikedByUser is TRUE then we use the DELETE route with the DELETE method.
      // Otherwise, we use the POST route to creat a new Like.

      const likeObj = feedItem.likes.find(
        (x) => x.item_id === feedItemId && x.user_id === thisUser.id,
      );

      // if (!likeObj) return;

      const endpoint = feedItem.liked
        ? `/${likeObj.id}`
        : `?item_type=${feedItem.itemType}&item_id=${feedItemId}`;

      fetch(API_ROUTE.LIKES + endpoint, { method }).then((res) => {
        vm.getLikes(feedItemId);
      });
    }

    async function updateComment(fetchMethod, commentData): Promise<any> {
      if (fetchMethod === "GET") return false;

      const { id, parentId, itemId, body, entities = [] } = commentData;
      let endpoint = `${API_ROUTE.COMMENTS}`;

      switch (fetchMethod.toUpperCase()) {
        case "DELETE":
          endpoint = `${endpoint}/${id}`;
          break;
        case "PUT":
          endpoint = `${endpoint}/${id}?body=${body}`; // IMPLEMENT ENTITIES HERE
          break;
        case "POST":
          endpoint = `${endpoint}?item_type=poll&item_id=${$scope.poll.id}&body=${body}`;
          if (parentId) endpoint = `${endpoint}&parent_id=${parentId}`;
          break;
        default:
          throw Error("[updateComment] Unexpected fetchMethod: " + fetchMethod);
      }

      const promise = await fetch(endpoint, { method: fetchMethod }).then(
        (res) => res.json(),
      );
      return Promise.resolve(promise);
    }

    function postComment(feedItemId = null) {
      if (!feedItemId) return false;

      if ($scope.reply.body) {
        let { id = null, item_id, body } = $scope.reply;
        const method = id != null ? "PUT" : "POST";

        if (!item_id) {
          item_id = feedItemId;
        }

        $scope.reply.saving = true;

        updateComment(method, { itemId: item_id, body }).then((res) => {
          $scope.reply = replyFormat;
          $scope.reply.body = "";
          $scope.reply.saving = false;
          toggleReplyBox(false);
          getComments(feedItemId);
        });
      }
    }

    async function saveReply(feedItemId) {
      $scope.reply.saving = true;

      await vm.updateComment("POST", $scope.reply).then((res) => {
        $scope.reply.saving = false;
        vm.getComments(feedItemId);
      });
    }

    /**
     * Retrieves events from the API
     * @return {void}
     */
    function getFeed() {
      vm.isLoading = true;

      FeedApi.get(
        vm.filters,
        (response) => {
          vm.feedItems = response.data;
          vm.feedLength = response.meta.pagination.total;
          vm.getFilterTitles();

          getLikesAndComments();
          checkRequested();

          vm.isLoading = false;
        },
        (error) => {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Updates filters and refreshes the events.
     * Called by the order events select control.
     *
     * @return {void}
     */
    function orderFeed() {
      angular.merge(
        vm.filters,
        vm.selectedOrderFilter,
        vm.orderdateFilter,
        vm.selectedOrderdateFilter,
      );
      vm.filters.label = null;
      getFeed();
    }

    $scope.loadMore = function () {
      vm.filters.per_page = vm.filters.per_page + 5;
      getFeed();
    };

    // Poll items script
    vm.vote = vote;

    /**
     * Sends the user's chosen option to the API, and shows the results
     * @param {object} feedItem - The poll voted on
     * @param {object} option - User's chosen option
     * @return {void}
     */
    function vote(feedItem, option) {
      feedItem.selectedOption = option;

      // if selected option not set.
      if (!feedItem.selectedOption.id) {
        return;
      }

      var data = {
        poll_option_id: feedItem.selectedOption.id,
      };

      PollVotesApi.vote(data, function (response) {
        feedItem.options = response.data.poll_options;
        feedItem.current_users_vote = feedItem.selectedOption.id;
      });
    }

    /**
     * Sends the connection request to the API
     * @return {void}
     */
    function requestResource(groupId, feedItem) {
      $scope.isLoadingMessage = "Sending request...";
      $scope.isLoading = true;

      GroupsApi.GroupUserRequest(
        { group_id: groupId },
        {
          user_id: thisUser.id,
        },
        function handleRequesttResponse(response) {
          $scope.isLoading = false;

          feedItem.userRequested = true;

          alerts.emit({
            theme: "success",
            title: "Request Sent",
            messages: [],
          });
        },
        function handleRequesttError() {
          $scope.isLoading = false;
          $scope.forceClose = true;
        },
      );
    }

    function checkRequested() {
      vm.feedItems.forEach(checkItem);

      function checkItem(item, index, a) {
        a[index].userRequested = false;

        if (item.group) {
          if (
            item.groupRequests.filter((o) => o.user_id === thisUser.id).length >
            0
          ) {
            a[index].userRequested = true;
          }
        }
      }
    }

    function bootstrap() {
      vm.getFeed();

      vm.isLoading = false;

      // console.log('$scope.authenticated', $scope.authenticated);

      document.body.addEventListener(
        "comments:refresh",
        function () {
          vm.getLikesAndComments();
        },
        false,
      );
    }

    bootstrap();
  }
})(angular);
